module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.1.1Rc.7 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 支持 PC 上鼠标选择 #1039 @michael829")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/picker.html"
    }
  }, [_vm._v("Picker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 支持 PC 上鼠标选择 #1039 @michael829")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popup-picker.html"
    }
  }, [_vm._v("PopupPicker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 支持 PC 上鼠标选择 #1039 @michael829")]), _vm._v(" "), _c('li', [_vm._v("[enhance] 支持根据值自定义显示格式")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/swipeout.html"
    }
  }, [_vm._v("Swipeout")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复 Android 下按钮点击事件不触发问题 #1044 @tangtaoit")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/tab.html"
    }
  }, [_vm._v("Tab")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持定义 bar 宽度")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复初始化时没有 tab-item 时导致报错 #1038 @liu2010y")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-address.html"
    }
  }, [_vm._v("XAddress")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 支持 PC 上鼠标选择 #1039 @michael829")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-number.html"
    }
  }, [_vm._v("XNumber")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 在 nextTick 后触发 on-change 事件")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-361a50d4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-361a50d4"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.1.1-rc.7-215.vue
// module id = 2146
// module chunks = 339